$.widget("ui.autocomplete", $.ui.autocomplete, {
	_renderItemData: function (ul, item) {
		var regex = /(<([^>]+)>)/ig;
		item.value = item.value.replace(regex, "");
		return this._renderItem( ul, item ).data( "ui-autocomplete-item", item );
	}
});
